import { Heading, P, Section, Wrapper } from 'components/base';
import PropType from 'prop-types';
import React from 'react';
import CheckIcon from 'svgs/icons/check-circle.svg';
import { bContent, bList, checkIconC, image, item, listC } from './TwoColList.module.scss';

const Item = ({ heading, content, list, img }) => (
  <div className={item}>
    <div className={bContent}>
      {
        img ? <img src={img.publicURL} alt={heading} className={image} /> :
        <div>
          <Heading Tag="h2" size="M" bold marginBottom="Xxs">
            {heading}
          </Heading>
          <P Tag="h3">{content}</P>
        </div>
      }
    </div>
    <div className={bList}>
      <div className="mt-xs">
        <ul className="unordered-list">
          {list.map((item, i) => (
            <li key={i} className={listC}>
              <CheckIcon className={checkIconC} />
              <div>
                <P Tag="h3" size="XL" bold>{item.heading}</P>
                <P Tag="p">{item.content}</P>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
Item.propTypes = {
  heading: PropType.string.isRequired,
  content: PropType.string.isRequired,
  list: PropType.array.isRequired,
  img: PropType.shape({
    publicURL: PropType.string,
  })
};
Item.defaultProps = {
  heading: "",
  content: "",
  img: null
}

const TwoColList = ({ data, padding, theme }) => (
  <Section padding={padding} theme={theme}>
    <Wrapper size="ML">
      {data.map((props, i) => (
        <Item {...props} key={i} />
      ))}
    </Wrapper>
  </Section>
);
TwoColList.propTypes = {
  data: PropType.array.isRequired,
  padding: PropType.string.isRequired,
  theme: PropType.string,
};
TwoColList.defaultProps = {
  padding: 'L',
  theme: null,
}

export default TwoColList;
